document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const productPriceAndRatings = document.querySelector('.product__price-and-ratings');
    const productPageBadge = document.getElementById('product-page-multiplier_badge');
    const featuredProductBadge = document.getElementById('featured-product-multiplier_badge');

    function positionBadge(badgeWrapper, priceElement) {
      const badge = badgeWrapper.querySelector('.badge-wrapper');
      if (badge) {
        badge.classList.remove('badge-wrapper');
        badge.classList.add('override-badge');
      }
      priceElement.parentNode.appendChild(badgeWrapper);
    }

    if (productPageBadge && productPriceAndRatings) {
      positionBadge(productPageBadge, productPriceAndRatings);
    }

    if (featuredProductBadge) {
      const featuredProductPrice = featuredProductBadge.closest('.product').querySelector('.product__price-and-ratings');
      if (featuredProductPrice) {
        positionBadge(featuredProductBadge, featuredProductPrice);
      }
    }
  }, 100);
});
